export enum SemesterEnum {
    First = 0,
    Second = 1,
}

export function getSemesterEnumLabel(value: SemesterEnum): string {
    switch (value) {
        case SemesterEnum.First:
            return "enum.semester.first";
        case SemesterEnum.Second:
            return "enum.semester.second";
        default:
            return "common.unknown";
    }
}
